import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer id="footer">
        Copyright &#169; 2023 Sherwen Palima. All right received.
    </footer>
  )
}

export default Footer
